import dynamic from "next/dynamic";
import { ComponentConfig } from "@zapier/builder.io-kit";
import { iconNames } from "@zapier/design-system";

export const popoverConfig: ComponentConfig = {
  name: "Popover",
  category: "Pricing",
  component: dynamic(() => import("./Popover")),
  canHaveChildren: true,
  inputs: [
    { name: "id", type: "string", required: true },
    {
      name: "trigger",
      type: "object",
      required: true,
      subFields: [
        {
          name: "label",
          type: "string",
          required: true,
          helperText: "The text that appears on the trigger button",
        },
        {
          name: "icon",
          type: "string",
          enum: ["", ...Object.keys(iconNames)],
          helperText: "The icon that appears on the trigger button",
        },
      ],
      defaultValue: {
        label: "Learn about tasks",
        icon: "actionCalendar",
      },
    },
    {
      name: "content",
      type: "object",
      subFields: [
        {
          name: "title",
          type: "string",
          helperText: "The title of the popover",
        },
        {
          name: "description",
          type: "richText",
          helperText: "The description of the popover",
        },
        {
          name: "ariaLabel",
          type: "string",
          required: true,
          helperText:
            "The aria-label property of the popover content used by assistive technologies. Not visible in the UI",
        },
      ],

      defaultValue: {
        title: "What are tasks?",
        description: `A task is an action your automated workflow successfully completes. 
        For example, if your Zap has an action to create new Google Contacts, each contact Zapier creates will count as one task.
        <br />
        <br />
        <a href="https://zapier.com/how-it-works">Learn more about task usage and how Zapier works</a>
        `,
        ariaLabel: "Learn about tasks",
      },
    },
  ],
};
